<template>
  <div class="search-content-wrap" shadow="always" style="padding:10px;">


    <div class="searchContent-wrap">
      <div class="card_content">
        <div class="content_title_wrap">
          <div class="content_title pointer" @click="handleRoom">
            <!-- <div class="title_left" v-if="lang == 'ch'">{{exhObject.exh_name}}</div>
            <div class="title_left" v-else>{{exhObject.exh_name_en}}</div> -->
            <!--展会状态-->
            <div
                class="title_right"
                :class="exhObject.exh_type == ExhibitionTypeEnum.HAS_ENDED ||
                    exhObject.exh_type == ExhibitionTypeEnum.END_HAS_ENDED ? 'state': 'carry' "
                :style="{width: (lang == 'ch' ? '' : '130px')}"
                v-if="exhObject.exh_type_text == '' &&
                    exhObject.exh_type != 1&&
                    exhObject.exh_type != 6
                      "
            >
              <el-button :class="exhObject.exh_type == 3 ? 'endExh' : 'underWay'"  round>{{exhObject.exh_type | stateText(ExhibitionType)}}</el-button>
              <!--                <div class="wrap" v-if="exhObject.exh_type == ExhibitionTypeEnum.ONGOING">-->
              <!--                  <ul class="animation">-->
              <!--                    <li class="animation_one"></li>-->
              <!--                    <li class="animation_two"></li>-->
              <!--                    <li class="animation_three"></li>-->
              <!--                  </ul>-->
              <!--                </div>-->
            </div>
            <!--展会剩余天数-->
            <div class="title_day" v-else-if="exhObject.exh_day_hour > 0">
              <img src="../../assets/img/clock.png" style="position: relative;top: 3px;left: -2px;">
              {{language.cluesTime1}}
              <div
                  class="title_span moreThanFive"

                  v-if="exhObject.exh_type_text != 0"
              >{{exhObject.exh_type_text}}</div>
              <span v-if="exhObject.exh_type_text != 0">{{language.cluesTime2}}</span>
              <div
                  class="title_span moreThanFive"

              >{{exhObject.exh_time_hour}}</div>
              {{language.cluesTime3}}
            </div>
          </div>
        </div>

        <div class="card_content-left">
<!--          <div class="angle"></div>-->
          <img v-if="lang=='ch'" :src="exhObject.exh_share_pic || exhObject.exh_share_pic_en" alt="" style="border: 10px solid #FFFFFF;cursor: pointer;" @click="handleRoom">
          <div class="bg-img"></div>
        </div>
        <div class="card_content-right">
<!--          <div class="content_title_wrap">-->
<!--            <div class="content_title pointer" @click="handleRoom">-->
<!--              &lt;!&ndash; <div class="title_left" v-if="lang == 'ch'">{{exhObject.exh_name}}</div>-->
<!--              <div class="title_left" v-else>{{exhObject.exh_name_en}}</div> &ndash;&gt;-->
<!--              &lt;!&ndash;展会状态&ndash;&gt;-->
<!--              <div-->
<!--                class="title_right"-->
<!--                :class="exhObject.exh_type == ExhibitionTypeEnum.HAS_ENDED ||-->
<!--                    exhObject.exh_type == ExhibitionTypeEnum.END_HAS_ENDED ? 'state': 'carry' "-->
<!--                :style="{width: (lang == 'ch' ? '' : '130px')}"-->
<!--                v-if="exhObject.exh_type_text == '' &&-->
<!--                    exhObject.exh_type != 1&&-->
<!--                    exhObject.exh_type != 6-->
<!--                      "-->
<!--              >-->
<!--                <el-button style="width: 126px;height: 40px;background: rgb(244,121,0,0.5);color: #FFFFFF;" round>{{exhObject.exh_type | stateText(ExhibitionType)}}</el-button>-->
<!--&lt;!&ndash;                <div class="wrap" v-if="exhObject.exh_type == ExhibitionTypeEnum.ONGOING">&ndash;&gt;-->
<!--&lt;!&ndash;                  <ul class="animation">&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="animation_one"></li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="animation_two"></li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="animation_three"></li>&ndash;&gt;-->
<!--&lt;!&ndash;                  </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;展会剩余天数&ndash;&gt;-->
<!--              <div class="title_day" v-else-if="exhObject.exh_day_hour > 0">-->
<!--                {{language.cluesTime1}}-->
<!--                <div-->
<!--                  class="title_span"-->
<!--                  :class="exhObject.exh_type_text >= 5 ? 'moreThanFive': 'lessThanFive' "-->
<!--                >{{exhObject.exh_type_text}}</div>-->
<!--                {{language.cluesTime2}}-->
<!--                <div-->
<!--                  class="title_span"-->
<!--                  :class="exhObject.exh_type_text >= 5 ? 'moreThanFive': 'lessThanFive' "-->
<!--                >{{exhObject.exh_time_hour}}</div>-->
<!--                {{language.cluesTime3}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->


          <!-- <div
            class="content_time pointer"
            @click="handleRoom"
          >{{language.exhibitionTime}}: {{exhObject.exh_begtime}} —— {{exhObject.exh_endtime}}</div> -->
          <div class="textbtn-wrap">
            <!--招聘时间-->
            <div class="title_left" v-if="lang == 'ch'">{{exhObject.exh_name}}</div>
<!--            <div class="recruit_time">招聘会时间:-->
<!--              <span>{{exhObject.exh_begtime}}</span> 至 <span>{{exhObject.exh_endtime}}</span>-->
<!--            </div>-->
            <div class="content_introduce pointer" @click="handleRoom" >
              <p class="exh_inter"  v-html="exhObject.exh_introduce" style="">{{exhObject.exh_introduce}}</p>
            </div>
            <div style="color: #f47900;font-weight: 600;position: absolute;top: 310px;">应届高校毕业生，WIFFA云聘免费</div>
            <div class="content_btn">
              <div class="content_btn_wrap">

                <!-- 线上 exhObject.exhibition_id != 29 && (exhObject.is_free != 1 || !token)-->

                <!--&& exhObject.ExhEndtime > ((new Date()).getTime()/1000)-->

                <!--我要报名-->
                <el-button
                  type="primary"
                  class="btn"
                  style="border-radius: 4px;background: #0071ff;border: none;cursor: pointer;font-size: 18px;color: #FFFFFF;width: 157px;height: 54px;margin-left: 0px;margin-right: 40px;"
                  @click="handleRegister(1)"
                  v-if="exhObject.exh_type!=3 && exhObject.exhibition_id != 29"
                >
                <img src="../../assets/icon-index-btn-bm.png" alt="">
                {{language.exhibitionSignup}}
                </el-button>

<!--                <el-button-->
<!--                  type="primary"-->
<!--                  class="btn-join"-->
<!--                  @click="handleRoom"-->
<!--                  style="background-color: #0071ff;border-radius: 4px;border: none;cursor: pointer;margin-right: 40px;font-size: 18px;color: #FFFFFF;margin-left: 0px;"-->
<!--                >-->
<!--                  <img src="../../assets/icon-index-btn-join.png" alt="">-->
<!--                  <span>{{language.joinVenue}}</span>-->
<!--                </el-button>-->


                <el-button
                    type="primary"
                    class="btn"
                    style="width: 157px;height: 54px;background: #f47900;border: none;cursor: pointer;margin-right:40px;border-radius: 4px;font-size: 18px;color: #FFFFFF;margin-left: 0px;"
                    @click="handleRegister(2)"
                    v-if="exhObject.exh_type!=3 && exhObject.exhibition_id != 29"
                >
                  <img src="../../assets/icon-index-btn-pay.png" alt="">
                  {{language.exhibitionPay}}
                </el-button>

                <!--我要做广告-->
                <a href="adintroduce.html" >
                <el-button
                    type="primary"
                    class="btn-join"
                    style="background-color: #0071ff;border-radius: 4px;border: none;cursor: pointer;margin-right: 0px;font-size: 18px;color: #FFFFFF;margin-left: 0px;"
                >
                  <img src="../../assets/img/ad.png" alt="">
                  <span>我要做广告</span>
                </el-button>
                </a>

                <!--我要观展 buyType : 1-->
                <!-- <el-button
                  type="primary"
                  class="btn"
                  style="background: #0f408a;border: none;cursor: pointer"
                  @click="handleWatch"
                  v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            "
                >{{language.exhibitionVisit}}</el-button> -->
                <!--我要参展 buyType : 2 -->
                <!-- <el-button
                  type="primary"
                  class="btn"
                  style="background: #0f408a;border: none;cursor: pointer"
                  @click="handleJoin"
                  v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            "
                >{{language.participation}}</el-button> -->

              <!--我要支付-->

                <!-- v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            " -->
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div v-if="exhObject.file_path"  style="width:100%;margin-top:10px;"><img :src="exhObject.file_path" alt="" style="width:1200px;height:auto;"></div>
  </div>

</template>

<script>
import {
  ExhibitionType,
  ExhibitionTypeEnum,
  ExhibitionHandleEnum,
  loginType
} from "../../common/constant/exhibition";
import { mapGetters } from "vuex";
export default {
  props: {
    language: {
      type: Object,
      default: () => {}
    },
    exhObject: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String
    },
    exhIndex: {
      type: String
    }
  },
  data() {
    return {
      ExhibitionType,
      ExhibitionTypeEnum,
      ExhibitionHandleEnum,
      loginType
    };
  },
  methods: {
    //参展
    handleJoin() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.JOIN_EXH,
        this.exhObject.exhibition_id
      );
    },
    //观展
    handleWatch() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.VIEW_EXH,
        this.exhObject.exhibition_id
      );
    },
    //进入会场
    handleRoom() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.ENTER_ROOM,
        this.exhObject.exhibition_id
      );
    },
    //我要支付
    handleRegister(type) {
        this.$emit(
            "join-handleRegister",
            this.ExhibitionHandleEnum.BUY_TICKET,
            this.exhObject.exhibition_id,
            type
        );


    },


  },
  computed: {
    ...mapGetters(["token","userInfo"])
  }
};
</script>

<style lang="css" scoped>
.pointer {
  cursor: pointer;
}
/* .home-secondtongAd{
  height:170px;
  width:1200px;
  position:absolute;
  left:0;
  bottom:300px;
}

.home-secondtongAd img{
  width:100%;
  height:100%;
} */
.card_not_data {
  font-size: 20px;
  text-align: center;
  line-height: 232px;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}
.searchContent-wrap{
  width: 1200px;
  height: 480px;
  display: flex;
  font-size: 16px;
  color: #fff;
  background: rgb(0,113,255,0.03);
  /*padding-bottom: 20px;*/
  /*opacity: 0.03;*/
}
.card_content_left{
  padding-top: 25px;
  /* flex: 1; */
}
.card_content_left_wrap{
  /* display: flex; */
}
.card_content_left_wrap_flex1{
  /* flex: 1; */
  float: left;
}
.card_content_left_wrap_flex1 img{
  width: 25px;
  height: auto;
  padding-top: 10px;
  padding-right: 10px;
}
.card_content_left_wrap_flex2{
  /* flex: 1; */
  max-width: 150px;
}
.card_content_left_wrap_flex2-begtime{
  margin: -10px 35px 58px 10px;
  line-height: 21px;
  /* margin-top: -10px; */
}
.card_content_left_wrap_flex2-endtime{
  margin: 58px 35px 0px 10px;
  line-height: 21px;
  /* margin-top: -10px; */
}

.card_content {
  /* flex: 4; */
  /* display: flex; */
  /* display: -webkit-flex; */
  flex-direction: column;
  width: 1200px;
}
.search-content-wrap:nth-child(2n) .card_content-left .bg-img {
  width: 160px;
  height: 160px;
  background-color: #0071ff;
  opacity: 0.17;
  position: absolute;
  top:217px;
  left: -20px;
  z-index: -1;
}
.bg-img {
  width: 160px;
  height: 160px;
  background-color: #0071ff;
  opacity: 0.17;
  position: absolute;
  top:217px;
  left: 425px;
  z-index: -1;
}
.search-content-wrap:nth-child(2n) .card_content-left img {
  margin-left: -3px;
}
.search-content-wrap{
  position:relative;
}
.search-content-wrap:nth-child(2n) .card_content-left{
  position: relative;
  float: left;
  width: 548px;
  height: 340px;
  background: transparent;
  margin-left: 20px;
  margin-right: 32px;

}
.card_content-left{
  position: relative;
  float: right;
  width: 548px;
  height: 340px;
  background: transparent;
  border: 0 !important;
  margin-top: 70px;
  margin-right: 37px;
}
.card_content-left .angle {
  position: absolute;
  top: 0px;
  right: -30px;
  width: 0;
  height: 0;
  border-bottom: 40px solid #f4f4f4;
  border-right: 30px solid transparent;
}
.search-content-wrap:nth-child(2n) .card_content-left .angle{
  position: absolute;
  top:0px;
  left: -30px;
  width: 0;
  height: 0;
  border-bottom: 40px solid #f4f4f4;
  border-left: 30px solid transparent;
  border-right: 0px solid transparent;
}
.card_content-left img{
  width: 100%;
  height: 100%;
}
.search-content-wrap:nth-child(2n) .card_content-right{
  /*margin-left: 20px;*/
  position: relative;
  padding-top: 30px;
  padding-right: 0px;
  float: left;
  width: 550px;
  margin-left:10px;
}
.card_content-right{
  position: relative;
  padding-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
  float: right;
  width: 580px;
  margin-top:50px;
}
/*.search-content-wrap:nth-child(2n)  .content_title_wrap{*/
/*  position: absolute;*/
/*  top: -5px;*/
/*  right: 80px;*/
/*}*/
.content_title_wrap{
  /*position: absolute;*/
  /*top: 35px;*/
  /*right: -200px;*/
  width: 20px;
}
.content_title_wrap .title_day {
  /*position: relative;*/
  /*top: 10px;*/
  /*right: 160px;*/
}
.textbtn-wrap{
  width: 100%;
  height: 100%;
}
.search-content-wrap:nth-child(2n)  .textbtn-wrap{
  background:transparent;
}
.content_title {
  /*float: right;*/
  /*display: flex;*/
  display: -webkit-flex;
  justify-content: space-between;
  width: 1200px;
  height: 40px;
  text-align: right;
  position: absolute;
}
.search-content-wrap:nth-child(2n) .card_content-right .content_btn {
  /* display: flex;
  display: -webkit-flex;
  flex-direction: row-reverse; */
  margin: 0 auto;
}
.content_btn {
  /* display: flex;
  display: -webkit-flex;
  flex-direction: row-reverse; */
  margin: 0 auto;

}
.search-content-wrap:nth-child(2n) .card_content-right .content_btn_wrap{
  width: 580px;
  margin: 5px auto 0;
  text-align: right;
  float: right;
  position: absolute;
  top: 335px;
  right: 0px;
}
.content_btn_wrap{
  margin: 0px auto 0px;
  text-align: left;
  padding-bottom: 40px;
  float: left;
  position: absolute;
  top: 337px;
}
.search-content-wrap:nth-child(2n)  .textbtn-wrap .title_left {
  width: 590px;
  height: 100%;
  max-height: 80px;
  font-family: SourceHanSansCN-Bold;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #333333;
  text-align: left;
  margin-bottom: 20px;
  overflow:hidden ;
}
.title_left {

  width: 590px;
  height: 100%;
  max-height: 80px;
  font-family: SourceHanSansCN-Bold;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #333333;
  text-align: left;
  margin-bottom: 20px;
  overflow: hidden;
}
.search-content-wrap:nth-child(2n)  .textbtn-wrap .recruit_time {
  width: 590px;
  height: 18px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #4384d7;
  margin-bottom: 30px;
  text-align: left;
}
.recruit_time {
  width: 590px;
  height: 18px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #4384d7;
  margin-bottom: 30px;
  text-align: left;
}
.content_time {
  font-family: MicrosoftYaHeiLight;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 0;
  color: #424242;
  padding: 20px 0 15px 0;
}
.search-content-wrap:nth-child(2n)  .textbtn-wrap .content_introduce {
  width: 560px;
  height: 209px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 15px;
  color: #000000;
  text-align: left;
  margin-right: 10px;
  background: transparent;
}
.content_introduce {
  width: 560px;
  height: 209px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 15px;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  margin-right: 0px;
  background: transparent;
}
.content_introduce .exh_inter{
  /*height:155px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 7;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.btn {
  /* width: 100px; */
  height: 40px;
  /* margin-top: 50px; */
}
.btn img{
  width: 20px;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 10px;
}
.btn span{
  padding-top: 5px;
}
.btn-join{
  /* width: 100px; */
  width: 157px;
  height: 54px;
  /* padding-top: 3px; */
}
.btn-join img{
  width: 20px;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 10px;
}
.btn-join span{
  padding-top: 5px;
}
.title_span {
  /* width: 35px;
  height: 29px; */
  line-height: 29px;
  border-radius: 4px;
  font-size: 20px;
  display: inline-block;
  text-align: center;
  /* margin: 0 10px; */
}
.lessThanFive {
  color: #f47900;
  font-size: 35px;
  font-weight: bold;
}
.moreThanFive {
  font-size: 50px;
  padding-left: 5px;
  padding-right: 5px ;
  /* border: 1px solid #f47900; */
  color: #f47900;
  margin-bottom: -5px;
}
.underWay {
  width: 126px;
  height: 40px;
  background: rgb(244,121,0,0.5);
  color: #FFFFFF;
  position: relative;
  left: 1040px;
  top: 15px;
}
.endExh {
  width: 126px;
  height: 40px;
  background: rgb(0,113,255,0.5);
  color: #FFFFFF;
  position: relative;
  left: 1040px;
  top: 15px;
}
.title_right {
  font-size: 20px;
  line-height: 26px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.search-content-wrap:nth-child(2n) .card_content-right .state {
  width: 74px;
  height: 26px;
  color: #a1a1a1;
  position: relative;
  left: 400px;
  /*background-color: #e6e6e6;*/
}
.state {
  width: 74px;
  height: 26px;
  color: #a1a1a1;
  /*background-color: #e6e6e6;*/
}
.title_day {
  width: 1200px;
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  /*margin-top: -10px;*/
  color: #0071ff;
  /*position: relative;*/
  margin-top: 22px;
  margin-right: 20px;
}
.search-content-wrap:nth-child(2n) .card_content-right .carry {
  width: 100px;
  height: 29px;
  border-radius: 4px;
  /*border: solid 1px #f47900;*/
  /*color: #f47900;*/
  position: relative;
  left: 400px;
}
.carry {
  width: 100px;
  height: 29px;
  border-radius: 4px;
  /*border: solid 1px #f47900;*/
  /*color: #f47900;*/
  position: relative;

}

.wrap ul {
  position: absolute;
  display: inline-block;
  vertical-align: center;
  right: 6px;
  top: 23px;
  transform: translateY(-50%);
  font-size: 0;
}
.wrap ul li {
  background-color: #f47900;
  display: inline-block;
  margin-left: 2px;
  width: 2px;
  height: 15px;
}
.animation_one {
  -webkit-animation: 0.8s 0.1s living linear infinite backwards normal;
  animation: 0.8s 0.1s living linear infinite backwards normal;
  -webkit-animation-delay: -1.1s;
}
.animation_two {
  -webkit-animation: 0.8s 0.3s living linear infinite backwards normal;
  animation: 0.8s 0.3s living linear infinite backwards normal;
  -webkit-animation-delay: -1.3s;
}
.animation_three {
  -webkit-animation: 0.8s 0.6s living linear infinite backwards normal;
  animation: 0.8s 0.6s living linear infinite backwards normal;
  -webkit-animation-delay: -1.6s;
}
@-webkit-keyframes living {
  0% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  50% {
    -webkit-transform: scaleY(0.3);
    transform: scaleY(0.3);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
}
@keyframes living {
  0% {
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  50% {
    -webkit-transform: scaleY(0.3);
    -ms-transform: scaleY(0.3);
    transform: scaleY(0.3);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  100% {
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
}
</style>
